import { clsx } from "clsx";
import { type FC } from "react";

import { SymbolIcon } from "widgets";

import style from "@/ui-modules/core/grid/styles/Cells.module.scss";

import { SmartLink } from "../../SmartLink.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { ENTITY_TYPE, UNKNOWN_GENOME_NAME } from "@/settings/settings.js";

const GenomeCell: FC<IAgGridCellProps> = (props) => {
  const { value, data, colDef } = props;

  if (data?.organism?.hidden) {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", columnGap: 3 }}>
        <SymbolIcon icon={"security"} className={clsx(style.cell_file_tag, style.cell_file_tag_error)} />
        [Restricted Genome]
      </span>
    );
  } else if (!data || !value || value === UNKNOWN_GENOME_NAME) {
    return null;
  }

  function createGenomeLink(genomeId: number) {
    const useExternal = (colDef as ICustomColDef).openLinkExternal;

    //in the registration playbook review screen, we want to show the genome unlinked by not providing a genomeId
    return genomeId ? (
      <TableCell>
        <SmartLink to={`/${ENTITY_TYPE.ORGANISM}/${genomeId}`} forceExternal={useExternal} tooltip={value}>
          {value}
        </SmartLink>
      </TableCell>
    ) : (
      <TableCell>{value}</TableCell>
    );
  }

  const field: string = colDef.field;

  if (field === "refGenome.name") {
    return createGenomeLink(data.refGenome.id);
  } else if (field === "genome.name") {
    return createGenomeLink(data.genome.id);
  } else if (field === "gene.genome.name") {
    return createGenomeLink(data.gene.genome.id);
  } else if (field === "protein.genome.name") {
    return createGenomeLink(data.protein.genome.id);
  } else if (field === "transcript.genome.name") {
    return createGenomeLink(data.transcript.genome.id);
  } else if (field === "variant.refGenome.name") {
    return createGenomeLink(data.variant.refGenome.id);
  } else if (field === "refVariant.genome.name") {
    return createGenomeLink(data.refVariant.genome.id);
  } else if (field === "refVariant.refGenome.name") {
    return createGenomeLink(data.refVariant.refGenome.id);
  } else if (field === "proteinLocation.protein.genome.name") {
    return createGenomeLink(data.proteinLocation.protein.genome.id);
  } else if (field === "variant.genome.name") {
    return createGenomeLink(data.variant.genome.id);
  } else if (field === "dataset.genome.name") {
    return createGenomeLink(data.dataset.genome.id);
  } else if (field === "organism.name") {
    return createGenomeLink(data.organism.id);
  }
};

export default GenomeCell;
